import AtomicContainer from "@components/Atomic/Container/Container";
import { Image } from "@components/Image/Image";
import { Link } from "@components/Link/Link";
import { StyledButton } from "@components/Styled/Button";
import { StyledContainer } from "@components/Styled/Container";
import { StyledH5 } from "@components/Styled/Text";
import React from "react";
import tw, { styled } from "twin.macro";
import { withFeaturedCollectionTiles } from "./withFeaturedCollectionTiles";

const Container = tw(AtomicContainer)`
  bg-neutral
`;
const Wrapper = tw(StyledContainer)`
  px-0 md:pb-tera md:pt-mega md:px-mega
`;
const Title = tw(StyledH5)`
  mb-midi uppercase ml-mini pt-midi md:ml-0
`;
const ContentWrapper = tw.div`
  flex flex-col md:flex-row
`;
const TileWrapper = tw.div`
  border-t border-tertiary w-full md:border-0 md:w-1/4
`;
const CollectionLink = tw(StyledButton)`
  relative z-10 block mr-0 no-underline bg-center bg-cover md:aspect-11-12 md:mr-2
`;
const CollectionTile = tw.div`items-center flex w-full md:block`;
const Gradient = styled.div`
  ${tw`absolute block w-full md:block`}
  ::after {
    ${tw`absolute top-0 left-0 block w-full h-full transition-opacity opacity-100 duration-slow`}
    content: "";
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.15) 0%,
      rgba(0, 0, 0, 0) 55%
    );
  }
  :hover::after {
    ${tw`opacity-0`}
  }
  > div {
    ${tw`hidden md:block`}
  }
`;
const ImageColumn = tw.div`
  flex items-center mr-mini md:hidden
`;
const ImageListWrapper = tw.div`
  inline-block mr-mini w-peta h-peta overflow-hidden
`;
const ContentColumn = tw.div`
  flex-grow
`;
const Content = tw.div`
  left-midi md:absolute
`;
const SectionTitle = tw(StyledH5)`
  pb-0 uppercase md:pb-mini md:text-white md:mt-2
`;
const SectionContent = tw.span`
  block font-display mb-mini mr-midi text-body md:text-white xl:text-h2
`;
const SectionContentLink = tw.span`
  hidden left-midi underline md:absolute md:block md:bottom-midi md:text-white
`;

const FeaturedCollectionTiles = withFeaturedCollectionTiles(
  ({ sectionLinks, title, styles }) => {
    return (
      <Container
        styles={styles}
        data-component-type="section-featured-collection-tiles"
      >
        <Wrapper>
          <Title>{title}</Title>
          <ContentWrapper>
            {sectionLinks?.map((section, index) => (
              <TileWrapper key={index}>
                <CollectionLink as={Link} to={section?.link?.url}>
                  <CollectionTile>
                    <Gradient>
                      <Image image={section?.image} />
                    </Gradient>
                    <ImageColumn>
                      <ImageListWrapper>
                        <Image ratio="1/1" image={section?.mobileImage} />
                      </ImageListWrapper>
                    </ImageColumn>
                    <ContentColumn>
                      <Content>
                        <SectionTitle>{section?.title}</SectionTitle>
                        <SectionContent>{section?.content}</SectionContent>
                      </Content>
                      <SectionContentLink>
                        {section?.link?.title}
                      </SectionContentLink>
                    </ContentColumn>
                  </CollectionTile>
                </CollectionLink>
              </TileWrapper>
            ))}
          </ContentWrapper>
        </Wrapper>
      </Container>
    );
  },
);

export default FeaturedCollectionTiles;
